import cloneDeep from 'lodash/cloneDeep'
import initialState from './state.js'

export default {
  RESET_DRE_DATA(state) {
    const initial = cloneDeep(initialState)
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key]
    })
  },
  SET_DRE_REVENUE_INCREMENT_METRICS(state, payload) {
    state.dreRevenueIncrementMetrics = payload
  },
  SET_DRE_OFFERS_COUPONS_METRICS(state, payload) {
    state.dreOffersCouponsMetrics = payload
  },
  SET_DRE_PRODUCTS_METRICS(state, payload) {
    state.dreProductsMetrics = payload
  },
  SET_DRE_CLIENTS_DISTRIBUTION_BEFORE(state, payload) {
    state.dreClientsDistributionBefore = payload
  },
  SET_DRE_CHANNELS_DISTRIBUTION(state, payload) {
    state.dreChannelsDistribution = payload
  },
  SET_DRE_ANALYSED_PERIOD(state, payload) {
    state.dreAnalysedPeriod = payload
  },
  SET_HAS_DRE_OFFERS_SCHEDULES_RESULTS(state, payload) {
    state.hasDreOffersSchedulesResults = payload
  },
  SET_DRE_ANALYTICS_CONFIGURATIONS(state, payload) {
    state.dreAnalyticConfigurations = payload
  },
}
